<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useCurrentUserVariable } from '#layers/filters/composables/use-current-user-variable';

const { fieldPath = null, showRemove = true } = defineProps<{
	fieldPath?: string | null;
	showRemove?: boolean;
}>();

defineEmits<{
	remove: [];
}>();

const { t } = useI18n();
const { getCurrentUserFieldPathLabels } = useCurrentUserVariable();

const segments = computed(() => fieldPath === null
	? [t('filters.current_user')]
	: [t('filters.current_user'), ...getCurrentUserFieldPathLabels(fieldPath)]);
</script>

<template>
	<DSegmentBadge :segments :show-remove class="mx-2" @remove="$emit('remove')" />
</template>
